module.exports = __webpack_public_path__ + "static/media/Pagos.0447905c.svg";